import React from "react";
import ContactService from "../../services/ContactService";
import NewsService from "../../services/NewsService";
import InvestmentService from "../../services/InvestmentService";
import ContactDraftService from "../../services/ContactDraftService";
import HistoricalAumService from "../../services/HistoricalAumService";
import RealEstateInvestmentService from "../../services/RealEstateInvestmentService";

function useInvestorUpdater(session, snackbar, drafts=false) {

    const contacts = async (contact) => {
        const parsedContact = {
            ...contact,
            responsibilities: contact.contact_responsibilities_ids.map((responsibility) => ({id: responsibility})),
            universities: contact.contact_universities_attributes || [],
            companies: contact.company_contacts_attributes || []
        }
        if (drafts) {
            await updateEntity(ContactDraftService, parsedContact, "Contact Draft");
        } else {
            await updateEntity(ContactService, parsedContact, "Contact");
        }
    }

    const investments = async (investment) => {
        await updateEntity(InvestmentService, investment, "Investment");
    }

    const realEstateInvestments = async (real_estate_investment) => {
        await updateEntity(RealEstateInvestmentService, real_estate_investment, "Real Estate Investment");
    }

    const news = async (pieceOfNews) => {
        await updateEntity(NewsService, pieceOfNews, "News");
    }

    const historicalAums = async (historicalAum) => {
        await updateEntity(HistoricalAumService, historicalAum, "Historical AUM");
    }

    const updateEntity = async (service, entity, entityName) => {
        try {
            const updateResponse = await service.update(entity.id, session, entity);

            if (updateResponse.data.status === 'success') {
                snackbar.show(`${entityName} updated successfully`, "success");
            } else {
                snackbar.show(updateResponse.data.message, "warning");
            }
        } catch (e) {
            console.error(e);
            snackbar.show(`Error when updating ${entityName}`, "warning");
        }
    }

    return {
        contacts,
        investments,
        realEstateInvestments,
        news,
        historicalAums,
    };
}

export default useInvestorUpdater;